import React from 'react';
import { Bar } from 'react-chartjs-2';
import { formatNumber } from '../../../../utils/functions';
import { useTranslation } from 'react-i18next';

const BarChart = ({ data, type }) => {
    const { t } = useTranslation();
    if (!Array.isArray(data) || data.length === 0) return null;

    const hours = data
        .map((day) => Number(day?.hour))
        .filter((hour) => Number.isFinite(hour));
    const allHours = Array.from(new Set(hours)).sort((a, b) => a - b);
    if (allHours.length === 0) return null;

    const impactValues = allHours.map((hour) => {
        const dataItem = data.find((item) => parseInt(item.hour) === hour);
        const impacts = Number(dataItem?.impacts);
        return Number.isFinite(impacts) ? impacts : 0;
    });

    let avgRequestsDay = 0;

    const reqValues = allHours.map((hour) => {
        const dataItem = data.find((item) => parseInt(item.hour) === hour);
        const avgReq = Number(dataItem?.avg_req);
        avgRequestsDay += Number.isFinite(avgReq) ? avgReq : 0;

        return Number.isFinite(avgReq) ? avgReq : 0;
    });

    avgRequestsDay = allHours.length ? avgRequestsDay / allHours.length : 0;

    let maxImpacts = Math.max(...impactValues);
    let minImpacts = Math.min(...impactValues);

    if (type == 'requests') {
        maxImpacts = Math.max(...reqValues);
        minImpacts = Math.min(...reqValues);
    }

    const gradient = impactValues.map((value) => {
        const range = maxImpacts - minImpacts;
        const normalizedValue = range === 0 ? 1 : (value - minImpacts) / range;
        const alpha = 0.3 + normalizedValue * 0.7;
        return `rgba(54, 162, 235, ${alpha})`;
    });

    const gradientReq = reqValues.map((value) => {
        let alpha = value <= 20 ? 0.45 : 1;
        return `rgba(245, 159, 138, ${alpha})`;
    });

    const chartData = {
        labels: allHours,
        datasets: [
            {
                type: 'bar',
                label: type,
                data: type === 'requests' ? reqValues : impactValues,
                backgroundColor: type === 'requests' ? gradientReq : gradient,
            },
        ],
    };

    if (type === 'requests') {
        const data = [];
        for (let i = 0; i < 24; i++) {
            data.push(avgRequestsDay);
        }
        chartData.datasets.push({
            type: 'line',
            data: data,
            backgroundColor: 'rgba(142, 142, 142, 0.0)',
        });
    }

    const chartOptions = {
        elements: {
            point: {
                pointStyle: 'line',
            },
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                        callback: function (value) {
                            return formatNumber(value, 'short');
                        },
                    },
                },
            ],
            xAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                        callback: function (value) {
                            return `${value} hs`;
                        },
                    },
                },
            ],
        },
        tooltips: {
            callbacks: {
                title: function (tooltipItem) {
                    const hour = tooltipItem[0].xLabel;
                    return `${hour} hs`;
                },
                label: function (tooltipItem) {
                    const valueToShow = tooltipItem.value;
                    return ` ${t(`common.words.${type}`)}: ${formatNumber(
                        valueToShow,
                        'impacts'
                    )}`;
                },
            },
        },
        legend: {
            display: false,
        },
    };

    return <Bar data={chartData} options={chartOptions} />;
};

export default BarChart;
